import { tss } from 'tss-react/mui';

import type { ThemeMode } from '@/types/theme.ts';

const useStyles = tss
  .withParams<{
    isLayoutMobile: boolean;
    themeMode: ThemeMode;
  }>()
  .create(({ theme, isLayoutMobile, themeMode }) => ({
    backButtonContainer: {
      padding: '0 !important',
      minWidth: '1.5rem',
      width: '1.5rem',
      boxShadow: theme.shadows[2],
      backgroundColor:
        themeMode === 'dark' ? '#49505e!important' : '#d5d7d8!important',
      borderRadius: 0,
      '&:hover': {
        backgroundColor:
          themeMode === 'dark' ? '#333c4d!important' : '#eceff1!important'
      }
    },
    vulnerabilityDetailsSubTopbar: {
      backgroundColor: theme.vars.palette.background.elevation1,
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-between',
      zIndex: 2,
      flex: 1,
      boxShadow: theme.shadows[2]
    },
    subTopbarTopContent: {
      boxShadow: isLayoutMobile ? theme.shadows[2] : 'none',
      display: 'flex',
      flexDirection: isLayoutMobile ? 'column' : 'row',
      gap: theme.spacing(2),
      justifyContent: 'space-between',
      padding: theme.spacing(3),
      width: '100%'
    },
    contentOrganizationName: {
      display: 'inline',
      fontSize: '1rem',
      fontWeight: 'normal'
    }
  }));

export default useStyles;
